import { createContext, useContext, useReducer } from 'react';
import { SupplierSearchState, SupplierSearchReducer, ACTION_TYPES } from './supplier-search-reducer';

const SupplierSearchContext = createContext<SupplierSearchState | undefined>(undefined);
const SupplierSearchDispatchContext = createContext({} as any);

const SupplierSearchProvider = ({ children }: { children: React.ReactNode }) => {
    const initialState: SupplierSearchState = { parameters: { page: 0, pageSize: 100 }, searchTrigger: 0 };
    const [state, dispatch] = useReducer(SupplierSearchReducer, initialState);
    return (
        <SupplierSearchContext.Provider value={state}>
            <SupplierSearchDispatchContext.Provider value={dispatch}>
                {children}
            </SupplierSearchDispatchContext.Provider>
        </SupplierSearchContext.Provider>
    );
};

const useSupplierSearchState = () => {
    const context = useContext(SupplierSearchContext);
    if (!context) throw new Error('useSupplierSearchState must be used within SupplierSearchProvider');
    return context;
};

const useSupplierSearchDispatch = () => {
    const context = useContext(SupplierSearchDispatchContext);
    if (!context) throw new Error('useSupplierSearchDispatch must be used within SupplierSearchProvider');
    return context;
};

export { SupplierSearchProvider, useSupplierSearchState, useSupplierSearchDispatch, ACTION_TYPES };
